module.exports = __webpack_public_path__ + "img/steps6-1.en.e0096a66.png";